import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './components/AuthProvider';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('toss_root'));

root.render(
    <QueryClientProvider client={queryClient}>
        <HashRouter>
            <React.StrictMode>
                <AuthProvider>
                    <App />
                </AuthProvider>
            </React.StrictMode>
        </HashRouter>
    </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
